import { render, staticRenderFns } from "./ZeroClick.vue?vue&type=template&id=1b0c9546&scoped=true"
import script from "./ZeroClick.vue?vue&type=script&lang=js"
export * from "./ZeroClick.vue?vue&type=script&lang=js"
import style0 from "./ZeroClick.vue?vue&type=style&index=0&id=1b0c9546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c9546",
  null
  
)

export default component.exports